import { StakingPositions } from "@/features/treasury/treasury";

export default function TreasuryStakingPage() {
  return <StakingPositions />;
}
